<template>
    <div class="el-card  pd20 special">
        <!-- 返回 -->
        <div class="cancel-box">
            <el-button type="info" icon="el-icon-arrow-left"  @click="$router.go(-1)"  size="medium">返回拼团列表</el-button>
        </div>
        <el-divider></el-divider>
        <!-- form -->
        <el-form  :model="form"  :rules="rules" ref="form" >
            <!-- 课程类型 -->
            <el-form-item label="课程类型" prop="status"  :label-width="formLabelWidth">
                <el-select v-model="form.status" placeholder="请选择课程" @change="courseTypeHandle" :disabled="is_edit">
                    <el-option v-for="(item,index) in course_list" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!-- 关联课程 -->
            <el-form-item label="关联课程" prop="bid"  :label-width="formLabelWidth">
                <el-select v-model="form.bid" placeholder="请选择课程" @click.native="courseNameHandle" :disabled="is_edit">
                    <el-option v-for="(item,index) in course_list2" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="拼团价格" prop="price"  :label-width="formLabelWidth">
                <el-input  v-model="form.price" class="price"  :disabled="is_edit"></el-input>元（拼团价格设置不得高于原价，且不得为0）
            </el-form-item>
            <!--  -->
            <el-form-item label="拼团人数" prop="num"  :label-width="formLabelWidth">
                <el-input  v-model.number="form.num" class="price"  :disabled="is_edit"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="拼团须知" prop="notice" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.notice" :disabled="is_edit"></el-input>
            </el-form-item>
            <!--  -->
             <el-form-item label="拼团时效" prop="aging"  :label-width="formLabelWidth">
                <el-date-picker
                    :disabled="is_edit"
                    v-model="form.aging"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd">
                </el-date-picker>&nbsp;&nbsp;&nbsp;
                <el-radio v-model="form.aging" label="无">无</el-radio>
                <p>选择无为即刻生效，并没有拼团倒计时，除非后台关闭拼团功能，否则长期有效。</p>
            </el-form-item>
            <!--  -->
            <el-form-item label="拼团时限"  prop="deadline"  :label-width="formLabelWidth">
                <el-radio-group v-model="form.deadline"  :disabled="is_edit">
                    <el-radio :label="24">24小时</el-radio>
                    <el-radio :label="48">48小时</el-radio>
                </el-radio-group>
                <p>在此期限内如果拼团不成功自动退款（如果活动剩余时间少于拼团时限以活动剩余时间为准）</p>
            </el-form-item>
            <!--  -->
            <el-form-item label="成为团长"  prop="foreman"  :label-width="formLabelWidth">
                <el-radio-group v-model="form.foreman"  :disabled="is_edit">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <p>无人发起拼团时，选择是则在前端展示发起拼团，成为团长那块区域，选择否则不展示。</p>
            </el-form-item>
            <!--  -->
            <el-form-item label="在线成团"  prop="corps_online"  :label-width="formLabelWidth">
                <el-radio-group v-model="form.corps_online"  :disabled="is_edit">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <p>当有人发起拼团时，选择是则是在前端展示去参团功能，用户可以直接在线成团，选择否则不展示</p>
            </el-form-item>
            <!--  -->
            <el-form-item label="模拟成团"  prop="corps_analog"  :label-width="formLabelWidth">
                <el-radio-group v-model="form.corps_analog"  :disabled="is_edit">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <p>开启模拟成团，当拼团时限或拼团活动结束前，人数未满的团，系统将会模拟“匿名”买家凑满人数，使其成团。</p>
                <!-- <p v-if="corps_analog>=1">模拟成团时限：<input type="text" v-model="form.corps_analog" class="auto-hour"  >小时</p> -->
            </el-form-item>
            <!--  -->
            <el-form-item label="拼团状态" prop="state"  :label-width="formLabelWidth">
                <el-radio-group v-model="form.state">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <!--  -->
            <el-form-item  :label-width="formLabelWidth">
                <el-button type="primary" @click="submitForm('form')" >提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template> 

<script>
import { scrabble_edit,scrabble_editdo  } from "@/api/operating";
export default {
    data() {
        return{
            formLabelWidth:'120px',
            list:[],
            form:{
                state:null,
                bid:null,
                status:null,
                notice:'',
                price:null,
                num:null,
                corps_online:null,
                foreman:null,
                corps_analog:null,
                deadline:null,
                aging:[]
            },
            course_list:[],
            course_list2:[],
            //这是一个验证规则
            rules:{
                corps_online:[{
                    required: true,
                    message: '请选择在线成团',
                    trigger: 'change'
                }],
                foreman:[{
                    required: true,
                    message: '请选择是否成为团长',
                    trigger: 'change'
                }],
                deadline:[{
                    required: true,
                    message: '请选择拼团时限',
                    trigger: 'change'
                }],
                notice: [{
                        required: true,//是否必填
                        message: '拼团须知不能为空',//错误提示信息
                        trigger: ['blur']//检验方式（blur为鼠标点击其他地方，）
                    }
                ],
                status: [{
                        required: true,//是否必填
                        message: '请选择类型',//错误提示信息
                        trigger: ['change','click']//检验方式（blur为鼠标点击其他地方，）
                    }
                ],
                bid: [{
                        required: true,//是否必填
                        message: '请选择课程',//错误提示信息
                        trigger: ['change','click']//检验方式（blur为鼠标点击其他地方，）
                    }
                ],
                price:[{
                    required: true,
                    message: '请输入拼团价格',
                    trigger: 'blur'
                }],
                corps_analog: [{
                        required: true,//是否必填
                        message: '请选择（填写）是否模拟成团',//错误提示信息
                        trigger: ['blur','change']
                    }
                ],
                state:[{
                    required: true,
                    message: '请选择拼团状态',
                    trigger: 'change'
                }],
                num: [{
                        required: true,//是否必填
                        message: '请填写拼团人数',//错误提示信息
                        trigger: 'blur'
                    }
                ],
                aging:[{
                    required: true,
                    message: '请选择拼团时效',
                    trigger: ['blur','change']
                }]
            },
            is_edit:false
        }
    },
    methods:{
        /*
         *@Description: 课程名称
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-14 16:13:27
        */
        courseNameHandle(){
            if(!this.form.status){
                this.$message({
                    message: '课程类型不能为空',
                    type: 'warning'
                });
                return;
            }
        },
        /*
         *@Description: 课程类型
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-14 16:03:06
        */
        courseTypeHandle(value){
            this.course_list.forEach((item,index)=>{
                if(item.id==this.form.status){
                    this.course_list2 = item.course;
                }
            });
        },
        // 提交数据
        save(){
            scrabble_editdo(this.form).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.$notify({
                    title: '成功',
                    message: '提交成功！',
                    type: 'success'
                });
                this.$router.go(-1);
            });
        },
        // 
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    if(this.form.aging instanceof Array){
                        this.form['aging_start'] = this.form.aging[0];
                        this.form['aging_end'] = this.form.aging[1];
                    }else{
                        this.form['aging_start'] = '';
                        this.form['aging_end'] = '';
                    }
                    // this.$delete(this.form,'aging');
                    this.save();
                } else {
                    this.$message.warning('请检查数据是否为空？');
                    return false;
                }
            });
        },
        pullData(){
            this.$showLoading();
            this.is_edit = this.$route.query.type === 'edit'?true:false;
            let obj = {};
            if(this.is_edit){
                obj['id'] = this.$route.query.id;
            }

            scrabble_edit(obj).then((data)=>{
                this.course_list = data.list.course;
                // 
                if(this.is_edit){
                    let userInfo = data.list.data;
                    this.form = userInfo;
                    if(userInfo.aging_start && userInfo.aging_end){
                        this.form.aging = [userInfo.aging_start,userInfo.aging_end];
                    }else{
                        this.form.aging = '无';
                    }
                    this.course_list.forEach((item,index)=>{
                        if(item.id==this.form.status){
                            this.course_list2 = item.course;
                        }
                    });
                }
             this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.special{
    .el-input,.el-textarea{
        width:775px;
    }
    .price{
        width: 500px;
        margin-right: 20px;
    }
}


.cancel-box{
    margin-bottom: 20px;
}
.up-image{
    margin: 20px auto auto;
    width: 187.5px;
    text-align: center;
    border-radius: 8px;
    .error{
        border-radius: 8px;
        background-color: rgba($color: #eeeeee, $alpha: .5);
    }
}
.auto-hour{
    margin-right: 20px;
    border-radius: 4px;
    padding: 8px 0px;
    padding-left: 15px;
}
.el-form-item{
    p{
        color: #999999;
    }
}
</style>
<style lang="scss">
// .special .el-select .el-input.is-disabled .el-input__inner{
//     background: rgba(0,0,0,0.6)!important;
// }
.el-date-editor .el-range-separator{
    width: 7%;
}
</style>
